import { mergeStyles } from "@fluentui/merge-styles";

export const emptyClasses = mergeStyles({
  fontSize: "12px",
  display: "flex",
  alignItems: "left",
  justifyContent: "left",
  textAlign: "left",
  color: "#797774",
  marginTop: 20,
  padding: "8px 16px",
  border: "1px solid #edebe9",
  boxShadow: "0 1.6px 3.6px 0 rgba(0,0,0,0.132), 0 0.3px 0.9px 0 rgba(0,0,0,0.108)",
  "&:hover": {
    boxShadow: "2px 1px 4px rgba(0,0,0, 0.3)",
  },
});

export const infoClass = mergeStyles({
  marginTop: 4,
  fontSize: "14px",
  marginLeft: 6,
  marginRight: 6,
});